import { Item } from "../types";

export const items: Item[] = [
  {
    id: "1",
    name: "Wol Item 1",
    color: "Rood",
    price: 25.99,
    thumbnail: "https://placehold.co/60x60/ff0000/ffffff?text=Wol1",
  },
  {
    id: "2",
    name: "Wol Item 2",
    color: "Blauw",
    price: 30.5,
    thumbnail: "https://placehold.co/60x60/0000ff/ffffff?text=Wol2",
  },
  {
    id: "3",
    name: "Wol Item 3",
    color: "Groen",
    price: 22.75,
    thumbnail: "https://placehold.co/60x60/00ff00/000000?text=Wol3",
  },
  {
    id: "4",
    name: "Wol Item 4",
    color: "Geel",
    price: 28.25,
    thumbnail: "https://placehold.co/60x60/ffff00/000000?text=Wol4",
  },
  {
    id: "5",
    name: "Wol Item 5",
    color: "Paars",
    price: 35.0,
    thumbnail: "https://placehold.co/60x60/800080/ffffff?text=Wol5",
  },
  {
    id: "6",
    name: "Wol Item 6",
    color: "Oranje",
    price: 27.5,
    thumbnail: "https://placehold.co/60x60/ffa500/000000?text=Wol6",
  },
  {
    id: "7",
    name: "Wol Item 7",
    color: "Roze",
    price: 32.99,
    thumbnail: "https://placehold.co/60x60/ffc0cb/000000?text=Wol7",
  },
  {
    id: "8",
    name: "Wol Item 8",
    color: "Bruin",
    price: 24.75,
    thumbnail: "https://placehold.co/60x60/a52a2a/ffffff?text=Wol8",
  },
  {
    id: "9",
    name: "Wol Item 9",
    color: "Grijs",
    price: 29.99,
    thumbnail: "https://placehold.co/60x60/808080/ffffff?text=Wol9",
  },
  {
    id: "10",
    name: "Wol Item 10",
    color: "Zwart",
    price: 26.5,
    thumbnail: "https://placehold.co/60x60/000000/ffffff?text=Wol10",
  },
];
